import {post, get, postWithHeaders} from "../utility/fetch-util";
import { encode } from "base-64";
import {getOnLineStatusFromNavigator} from "../utility/hooks/useOnlineStatus";

/**
 * Sign the user in - authenticate with server to produce a cookie and store user on the session
 * @param {string} username The username representing a user.
 * @param {string} password The password that will authorise access to the user.
 * @param {function} progressPercentFunction The percentage for loading and progress indicators.
 */
export const signInUser = async (username, password, progressPercentFunction) => {
    const requestBody = { username: encode(username), password: encode(password), appVersion: '' };   //app version not checked for now
    return postWithHeaders('/api/security/sign-in-driver-portal', null, requestBody, progressPercentFunction, {}); //empty header so session ID not added - a new session will be started
}

export const signOutUser = async (progressPercentFunction) => {
    if(getOnLineStatusFromNavigator())
    {
        return post('/api/security/signout', null, null, progressPercentFunction);
    }
    else
    {
        return get('/api/security/signout', null, null, progressPercentFunction);
    }
}

/**
 * Get cookie value from a HTTP only cookie set by a servlet (not available to client JS)
 */
export const getValueFromCookieOnServer = async (cookieName, progressPercentFunction) => {
    return get('/api/security/value-from-cookie/' + cookieName, null, progressPercentFunction);
}

/**
 * Get username for passed in SSO token (set in DB as part of external or openId sign on)
 */
export const getUsernameUsingSSOToken = async (ssoToken, progressPercentFunction) => {
    return get('/api/security/user-for-sso-token/' + ssoToken, null, progressPercentFunction);
}

/**
 * Heartbeat for user session (also extends the session)
 */
export const checkDriverSession = async () => {
    return get('/api/security/heartbeat-driver-portal/', null, null);
}

/**
 * Change the user password after expiry or if asked (must be logged in)
 */
export const changePassword = async (oldPassword, newPassword, progressPercentFunction) => {
    const params = { oldPassword: oldPassword, newPassword: newPassword};
    return post('/api/security/changePassword', params, null, progressPercentFunction);
}

export const getApplicationVersion = async () => {
    return get('/api/security/version/', null, null);
}

export const getQuotationPortalLink = async (progress) => {
    return get('/api/security/quote-portal/', null, progress);
}

export const getUser = async(progress) => {
    return get('/api/security/user', null, progress);
}